import { Application } from 'stimulus';
import { definitionsFromGlob } from 'stimulus-vite-helpers';

const application = Application.start();
application.load(definitionsFromGlob(import.meta.glob('./**/*_controller.js', { eager: true })));
